export default __webpack_public_path__ + "app/images/theme-images/light/long-logo.svg";